import { Route, Routes, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import ProtectedAdminRoute from "./ProtectedAdminRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import { routesConfig } from "../configs/routes";

const alwaysPublicRouteKeys = new Set([
  'public-gallery',
  'verify-email',
  'forgot-password',
  'forgot-password-sent',
  'reset-password',
]);
const alwaysPublicRoutes = routesConfig.filter((r) => alwaysPublicRouteKeys.has(r.key));
const protectedRoutes = routesConfig.filter((r) => r.isProtected && !r.isAdmin);
const publicAuthRoutes = routesConfig.filter(
  (r) => !r.isProtected && !alwaysPublicRouteKeys.has(r.key),
);

const AllRoutes = () => {
  
  return (
    <Routes>
      {alwaysPublicRoutes.map((route) => (
        <Route
          key={route.key}
          path={route.path}
          element={
            <AppRoute
              routeKey={route.key}
              component={route.element}
              {...route.meta}
            />
          }
        />
      ))}

      <Route path="/admin" element={<ProtectedAdminRoute />}>
        {routesConfig
          .filter(route => route.isProtected && route.isAdmin)
          .map(route => (
            <Route
              key={route.key}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.element}
                  {...route.meta}
                />
              }
            />
          ))
        }
      </Route>

      <Route path="/" element={<ProtectedRoute />}>
        {protectedRoutes.map(route => (
            <Route
              key={route.key}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.element}
                  {...route.meta}
                />
              }
            />
          ))
        }
        <Route path="*" element={<Navigate replace to="/not-found" />} />
      </Route>

      <Route path="/" element={<PublicRoute />}>
        {publicAuthRoutes.map(route => (
            <Route
              key={route.key}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.element}
                  {...route.meta}
                />
              }
            />
          ))
        }
      </Route>
    </Routes>
  )
};

export default AllRoutes;